import React from 'react';
import { motion } from 'framer-motion';
export function TitleBlock() {
  return <section className="py-10 md:py-16 px-5 md:px-6" data-id="element-199">
      <div className="max-w-2xl mx-auto text-center" data-id="element-200">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} data-id="element-201">
          <div className="border-t border-b border-charcoal/10 py-8 md:py-12" data-id="element-202">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif font-bold text-charcoal mb-3 md:mb-4" data-id="element-203">
              The 14‑Day "Quiet House" Reset
            </h2>
            <p className="text-base md:text-lg text-muted-blue font-medium mb-4 md:mb-6" data-id="element-204">
              (for Solo Moms)
            </p>
            <p className="text-lg md:text-xl text-charcoal/80 leading-relaxed max-w-xl mx-auto font-serif italic" data-id="element-205">
              A fill‑in plan to turn chaos + overstimulation into a calmer home
              rhythm—without more help, money, or willpower.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}